/**
 * The modes of the block time record modal.
 */
export enum BlockTimeRecordModalModeEnum {
  Add = 'add',
  Edit = 'edit',
}
